import React from 'react';
import { PercentageArcs } from '../../components/PercentageArcs';

export class TopCategories extends React.Component<any, any> {
  getPercentagesFromAmounts(allCategories) {
    const categories = allCategories.slice(0, 3);
    const total = categories.reduce((accum, val) => {
      return accum + Number(val.total);
    }, 0);

    return categories.map((category) => {
      const percentage = Math.round((Number(category.total) / total) * 100);

      return {
        name: category.name,
        percentage,
      };
    });
  }

  render() {
    return (
      <div className='h-50-full top-categories-wrapper border-bottom-0'>
        <PercentageArcs
          title={'Top Categories'}
          className='h-100-full'
          data={this.getPercentagesFromAmounts(this.props.categories)}
        />
      </div>
    );
  }
}
